// Componente per la gestione Toolbar
import React from 'react';
import { set, get } from './Storage';
import axios from 'axios';
import Toggle from 'material-ui/Toggle';
//import RefreshIndicator from 'material-ui/RefreshIndicator';
import * as Colors from 'material-ui/styles/colors';
import PropTypes from 'prop-types';
import DepositToolsPage from './Page/DepositTools';
import KomodoToolbar from './KomodoToolbar';
import DashboardPVRToolbar from './DashboardPVRToolbar';
import { MGBadge } from "mgUiKit";

// Init Configuration
var AppSettings = get();

var componentName = AppSettings.appId + 'ToolbarComponent';

var styles = AppSettings.styles;

class Toolbar extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            showBalance: false,
            balance: "",
            bonusBalance:"",
            fido: "",
            tabActive: props.initialTabActive,
            alertProfile: props.alertProfile,
            badgeContent: '',
        }
        this.switchToolbar = this.switchToolbar.bind(this);
        this.handleTab = this.handleTab.bind(this);
        this.handleToggleBalance = this.handleToggleBalance.bind(this);
        this.refreshBalance = this.refreshBalance.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.showFooter && AppSettings['balanceOpened']) {
            this.handleToggleBalance();
        }
    }

    componentDidUpdate(prevProps){
        if (prevProps.alertProfile !== this.props.alertProfile) {
            this.setState({
                alertProfile: this.props.alertProfile
            });
        }
    }

    switchToolbar(mode) {
        this.props.switchToolbar(mode);
    }

    refreshBalance() {
        this.setState({
            showBalance: true,
            balance: "---",
            bonusBalance:"---"
        });
        var balance = "---";
        var bonusBalance="0";
        var fido = "";
        var url = AppSettings['env'].urlUserBoxGetBalance;
        this.context.setBalanceData(null);
        axios.get(url)
            .then(({ data, status, statusText }) => {
                this.context.setExternalToolbarBalance(data);
                if (data.errors.length == 0) {
                    this.context.setBalanceData(data);
                    balance = data.balance;
                    if(data.bonusBalance !=null){
                        bonusBalance = data.bonusBalance;
                        fido = data.fidoStr;
                    } 
                    try {
                        document.querySelectorAll("[data-ub-balance]").forEach(function (el) { el.innerHTML = balance });
                        document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = bonusBalance });
                        document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = fido });
                    }
                    catch (e) { }
                }
                this.setState({
                    balance: balance,
                    bonusBalance:bonusBalance,
                    showBalance: true,
                    fido: fido
                });
            })

            .catch(({ data, status, statusText }) => {
                this.setState({
                    balance: "---",
                    bonusBalance:"---",
                    showBalance: true
                });
            });
        // this.setState({
        //     showBalance: true,
        //     fido: "",
        //     //balance: <RefreshIndicator status="loading" size={22} left={90} top={0} />
        // });  
        // var balance = "--";
        // var bonusBalance = "0";
        // var fido = '';
        // var url = AppSettings['env'].urlUserBoxGetBalance;
        // axios.get(url)
        //     .then(({ data, status, statusText }) => {
        //         if (data.errors.length == 0) {
        //             balance = data.balance;
        //             fido = data.fidoStr;
        //             if(data.bonusBalance !=null){
        //                bonusBalance=data.bonusBalance;
        //             } 
        //             if(data.fido !== 0 ){
        //                 fido = data.fidoStr;
        //             }  
        //             try{
        //                 document.querySelectorAll("[data-ub-balance]").forEach(function(el){ el.innerHTML = balance });
        //                 document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = fido });
        //                 document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = bonusBalance });
        //                 }
        //                 catch(e){}
        //         }
        //         this.setState({
        //             balance: balance,
        //             bonusBalance:bonusBalance,
        //             showBalance: true,
        //             fido: fido
        //         });
        //     })

        //     .catch(({ data, status, statusText }) => {
        //         this.setState({
        //             balance: "--",
        //             showBalance: true,
        //             bonusBalance:"--",
        //             fido: '',                
        //         });
        //     });
    }

    handleTab(tab, event) {
        if (!this.props.showFooter) {
            this.setState({
                tabActive: tab
            });
        }
        this.props.handleTab(tab);
    }
    
    handleClose(){
        this.context.handleTab(false);
    }

    handleLogout(){
        window.location.href = AppSettings.urlLogout;
    }
    // mostra/nascondi il saldo
    handleToggleBalance() {
        var currentValueBalance = AppSettings['balanceOpened'];
        if (this.state.showBalance) {
            this.setState({
                showBalance: false,
                balance: "---",
                bonusBalance:"---",
                fido: '---',
            });
            var balance = false;
            try{
                // document.getElementById("mg-pvr-balance").checked = false;
                document.querySelectorAll("[data-ub-balance]").forEach(function(el){ el.innerHTML = "---" });
                document.querySelectorAll("[data-ub-bonus]").forEach(function(el){ el.innerHTML = "---" });
                document.querySelectorAll("[data-ub-min-balance]").forEach(function(el){ el.innerHTML = '---' });
                }
                catch(e){}
        }
        else {
            this.refreshBalance();
            var balance = true;
        }

        AppSettings['balanceOpened'] = balance
        set(AppSettings);

        if (currentValueBalance != balance) {
            if (typeof (Storage) !== "undefined") {
                localStorage.setItem(AppSettings["env"].localStorageToggleBalance, balance);
            }
        }
    }

    

    render() {
        var classToolbar = "user-box-toolbar";
        var classFooter = "full-toolbar";
        if (!this.props.showFooter) {
            classFooter += " mg-hide";
        }
        else {
            //classToolbar += " animated bounceInRight";
        }
        // console.log(this.state.isAlertProfileActive, this.state.isAlertProfileActive ? '!' : "Error");
        
        var iconStyleProfile = JSON.parse(JSON.stringify(styles.topIconStyle));
        var iconStyleNews = JSON.parse(JSON.stringify(styles.topIconStyle));
        var iconStyleCoupon = JSON.parse(JSON.stringify(styles.topIconStyle));
      //  var iconStylePanel = JSON.parse(JSON.stringify(styles.topIconStyle));
      
        if (!this.props.showFooter) {
            if (this.state.tabActive == 'profile') {
                iconStyleProfile.color = AppSettings.theme.primarycolor;
            }

            if (this.state.tabActive == 'news') {
                iconStyleNews.color = AppSettings.theme.primarycolor;
            }
          /*  if (this.state.tabActive == 'panel') {
                iconStylePanel.color = AppSettings.theme.primarycolor;
            }*/

            if (this.state.tabActive == 'coupon') {
                iconStyleCoupon.color = AppSettings.theme.primarycolor;
            }
        }


        // var userDescription = this.props.data.username;
        // if(this.props.data.userTypeDescription != ""){
        //     userDescription = 
        //                 <>
        //                     <span className="ub-profile"> {this.props.data.userTypeDescription + ' : '}</span>
        //                     {/* <span className="ub-username"> {userDescription} </span> */}
        //                 </>;
        // }      
        let htmlEsci =  <li id="user-box-chiudi" onClick={this.handleClose.bind(this)}>
                            <i className="fa-mg fa-mg-chevron-right"></i>
                        </li>;

        if(this.props.showFooter){
            htmlEsci =  <li id="user-box-logout" onClick={this.handleLogout.bind(this)}>
                            <i className="fa-mg fa-mg-log-off"></i>
                        </li>;
        }

        return (
            <div className={classToolbar} >
                <ul id="user-box-toolbar-list"  number={AppSettings["isPartner"]?3:4}>
                    {AppSettings["perms"].tabNews ?
                        <li onClick={this.handleTab.bind(this, "profile")} id="user-box-profilo"
                            className={(!this.props.showFooter && this.state.tabActive == 'profile') ? 'mg-active-tab' : ''}>
                                <i className="fa-mg fa-mg-user-2"></i>
                                {this.state.alertProfile ? <MGBadge badgeContent="!"/> : null}                              
                        </li>
                        : null}


                    {AppSettings["perms"].tabCoupon ?
                        <li onClick={this.handleTab.bind(this, "coupon")} id="user-box-bonus"
                            className={(!this.props.showFooter && this.state.tabActive == 'coupon') ? 'mg-active-tab' : ''}>
                                <i className="fa-mg fa-mg-promo-2"></i>
                                {this.props.countCoupon > 0 ?
                                        <MGBadge badgeContent={this.props.countCoupon}/>                                 
                                    : null 
                            }

                        </li>
                        : null}
                         {AppSettings["perms"].tabProfile ?
                        <li onClick={this.handleTab.bind(this, "news")} id="user-box-messaggi"
                            className={(!this.props.showFooter && this.state.tabActive == 'news') ? 'mg-active-tab' : ''}>
                            <i className="fa-mg fa-mg-mail-1"></i>
                            {this.props.countNews > 0 ?
                                    <MGBadge badgeContent={this.props.countNews}/>                                 
                                : null 
                            }
                        </li>
                        : null}

                        {htmlEsci}

                        {/*
                        <li id="user-box-chiudi" onClick={this.handleClose.bind(this)}>
                            <i class="fa-mg fa-mg-chevron-right"></i>
                        </li>

                         <li id="user-box-logout" onClick={this.handleLogout.bind(this)}>
                            <i className="fa-mg fa-mg-log-off"></i>
                        </li>  
                         */}
                       
                        {/*(AppSettings["perms"].tabControlPanel && AppSettings["isPartner"]) ?
                        <li onClick={this.handleTab.bind(this, "panel")} id="user-box-pannello"
                            className={(!this.props.showFooter && this.state.tabActive == 'panel') ? 'mg-active-tab' : ''}>
                            <IconButton iconClassName="fa fa-th"
                                iconStyle={iconStylePanel} />
                        </li>
                        : null*/}

                    <hr style={{ backgroundColor: AppSettings.theme.primarycolor }} />
                </ul>
               {/* <KomodoToolbar/>*/}
                {/* <DashboardPVRToolbar/> */}
                <div className={classFooter}>
                    <div id="user-box-nome">
                        <ul>
                            <li className="user-box-nome">{this.props.data.username}<br />
                            {this.props.data.userTypeDescription != "" ? 
                                <span
                                    className="user-box-tipologia">{this.props.data.userTypeDescription}</span> 
                                : null}
                            </li>

                            <li className="user-box-balance" style={{ textAlign: 'right' }}>
                                <Toggle                                
                                    label={this.state.showBalance ?
                                        "Saldo: "+this.state.balance+
                                        " Bonus: "+this.state.bonusBalance
                                        : 'Mostra Saldo'
                                    }
                                    onToggle={this.handleToggleBalance}
                                    toggled={this.state.showBalance}                                    
                                />
                            </li>
                            
                        </ul>
                    </div>
                    <div id="mg-user-profile-footer" className="cf">
                        {AppSettings['perms'].deposit && AppSettings.showdepositbuttonintoolbar?
                            <DepositToolsPage  classNameButton="toolbar-deposit-button"/>
                        : null}

                        {/* <a href={AppSettings.urlLogout} className="mg-logout-footer" title="Disconnetti">
                            <span style={{ color: Colors.grey500 }}>
                                <i className="fa fa-power-off"></i> Esci
                                </span>
                        </a>  */}
                        
                        <a title="Minimizza" href="#" onClick={this.switchToolbar.bind(this, 'compact')} style={{ float: 'right' }} className="mg-icona-riduci">
                            <span style={{ color: Colors.grey500 }}>
                                <i className="fa fa-compress"></i> Riduci
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

Toolbar.displayName = componentName;

// PropTypes validation
Toolbar.propTypes = {
    showFooter: PropTypes.bool,
    initialTabActive: PropTypes.string,
    switchToolbar: PropTypes.func,
    countNews: PropTypes.number,
    countCoupon: PropTypes.number,
    alertProfile: PropTypes.bool,
    countMission: PropTypes.number
};

// default props
Toolbar.defaultProps = {
    showFooter: true, // Abilita/disabilita la visualizzazione del footer.
    balance: "",
    bonusBalance:"",
    initialTabActive: "profile",
    switchToolbar: function () { },
    alertProfile: false

};
Toolbar.contextTypes = {
    handleTab: PropTypes.func,
    setBalanceData: PropTypes.func,
}
export default Toolbar;